import { createContext } from 'react'

export interface PWAContextType {
  isOnline: boolean
  isInstalled: boolean
  updateAvailable: boolean
  updateServiceWorker: () => void
}

export const PWAContext = createContext<PWAContextType | undefined>(undefined)
